import { ApiErrorResponse, ApisauceConfig } from 'apisauce';

export enum DefaultApiError {
  GET = 'GET_API_REQUEST_ERROR',
  POST = 'POST_API_REQUEST_ERROR',
  PUT = 'PUT_API_REQUEST_ERROR',
  PATCH = 'PATH_API_REQUEST_ERROR',
  DELETE = 'DELETE_API_REQUEST_ERROR',
  UNKNOWN = 'UNKNOWN_API_REQUEST_ERROR',
}

/**
 * ApiError will try to add request method to error object if it exists,
 * with this we can add some generic error messages based on request method type
 */
const getDefaultErrorType = (rawMethod: string | undefined): DefaultApiError | undefined => {
  if (typeof rawMethod !== 'string') {
    return rawMethod;
  }

  switch (rawMethod.toLowerCase() as Lowercase<Exclude<ApisauceConfig['method'], undefined>>) {
    case 'get':
      return DefaultApiError.GET;
    case 'post':
      return DefaultApiError.POST;
    case 'put':
      return DefaultApiError.PUT;
    case 'patch':
      return DefaultApiError.PATCH;
    case 'delete':
      return DefaultApiError.DELETE;
    default:
      return undefined;
  }
};

interface ApiErrorOptions {
  status: ApiErrorResponse<unknown>['status'];
  code?: string;
  subCode?: string;
  method?: string;
}

/**
 * provide additional information to api errors to be compatible with message reducer
 * - not all options are required, but can help with more detailed snackbar messages
 */
export class ApiError extends Error {
  error: string;

  status: number | undefined;

  code: string | undefined;

  method: string | undefined;

  subCode: string | undefined;

  showSnackbar: boolean;

  type: string | undefined;

  constructor(message: string, options: ApiErrorOptions) {
    super(message);
    this.error = message;
    this.status = options.status;
    this.method = options.method;
    this.code = options.code;
    this.subCode = options.subCode;
    this.showSnackbar = options.status !== 403;
    this.type = getDefaultErrorType(options.method);
  }
}
